module.exports = __webpack_public_path__ + "img/airPurifiers_1_0.c811a12a.png";